import React from "react";
import { Layout, Row, Col, Typography, Button, Input, Spin } from "antd";
import AuthorsTable from "./AuthorsTable";

const { Title } = Typography;
const { Footer } = Layout;

const CustomFooter = ({
  loading,
  authorName,
  authorEmail,
  authorPassword,
  setAuthorName,
  setAuthorEmail,
  setAuthorPassword,
  authors,
  _deleteAuthor,
  _addAuthor,
}) => {
  return (
    <Footer style={{ textAlign: "center" }}>
      <Row>
        {/* {user.isAdmin && ( */}
        <Col span={16} style={{ height: 120 }}>
          <Title level={4}>Create Author</Title>
          <Spin spinning={loading}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Input
                value={authorName}
                onChange={({ target }) => setAuthorName(target.value)}
                placeholder="Author Name"
                style={{ marginLeft: 20 }}
              />
              <Input
                value={authorEmail}
                onChange={({ target }) => setAuthorEmail(target.value)}
                placeholder="Author Email"
                style={{ marginLeft: 20 }}
              />
              <Input
                value={authorPassword}
                onChange={({ target }) => setAuthorPassword(target.value)}
                placeholder="Author Password"
                style={{ marginLeft: 20 }}
              />
              <Button onClick={_addAuthor} style={{ marginLeft: 20 }}>
                Add Author
              </Button>
            </div>
          </Spin>
        </Col>
        {/* )} */}
      </Row>
      <Row>
        <Col flex={2}>
          {authors && (
            <AuthorsTable decks={authors} onEditClick={_deleteAuthor} />
          )}
        </Col>
      </Row>
    </Footer>
  );
};

export default CustomFooter;
